export const BRANCHES_QUERY_KEY = 'branches'
export const BRANCHES_BRIEF_QUERY_KEY = 'branchesBrief'
export const BRANCHES_FINANCIAL_SETTINGS_QUERY_KEY = 'branchesFinancialSettings'
export const ALL_BRANCHES_QUERY_KEYS = 'allBranches'
